import React, { useEffect, useState, useContext } from 'react';
import WorkflowContext from '../../workflowContext';

import authApiService from '../../services/authApiService';

import axios from "axios"

export const FileDetails = (props) => {

    const workflow = useContext(WorkflowContext);

    // const [report, setReport] = useState("multiqc_report.html");
    // const [title, setTitle] = useState("Example Report: RNA-Seq");
    // const [description, setDescription] = useState("This is an example report for an RNA-Seq analysis. It contains a summary of the analysis, quality control metrics, and other useful information.");
    
    const [report, setReport] = useState(null);
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);
    
    // const [contentUrl, setContentUrl] = useState("https://d25oyg0nh7apoq.cloudfront.net/");
    const [contentUrl, setContentUrl] = useState("");
    const [showFrame, setShowFrame] = useState(false);


    async function workflow_data(workflow) {

        const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getDataUserToken}`,
        };
        
        const response = await axios.get( 
            `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/workflow/${workflow}?userId=${getDataUserId}`, {
                headers,
        })

        const data = await response.data;
        return data;
    }

    useEffect(() => {

        Promise.resolve(workflow_data(workflow)).then((wf_data) => {

            if (wf_data.multiQcReport) {
                setReport(wf_data.multiQcReport);
            }

            if (wf_data.name) {
                setTitle(wf_data.name);
            }

            if (wf_data.multiQcReportDescription) {
                setDescription(wf_data.multiQcReportDescription);
            }

            if (wf_data.contentUrl) {
                setContentUrl(wf_data.contentUrl);
            }

            setShowFrame(true);

        }).catch((error) => {
            console.error("err from post dataset",error)
        });


    }, [workflow]);

    useEffect(() => {
        document.title = `MultiQC Report | ${title}`;
    });

    useEffect(() => {
        authApiService.getAllStaticContentUrlsApi().then(res => {
            setContentUrl(res.allStaticcontenturls.edges[0].node.url);
        });
    });

return (
    <main className="min-h-[calc(100vh-4rem-24rem)]">
        <div className="container-lg py-10 lg:py-20 mt-5">  
            <div className="prose max-w-none dark:prose-invert">
                <p>{description}</p>
                <div className="mt-8">
                    <div className="overflow-hidden rounded-md border border-gray-200 text-gray-800 shadow">
                        <div className="overflow-hidden rounded-md border border-gray-200 shadow">
                            <div className="flex border-b border-gray-200 bg-gray-100">
                                <div className="flex px-4 pb-2 pt-4">
                                    { showFrame && <span className="typo-small -mt-0.5">{title}</span>}
                                </div>
                            </div> 
                            <div>
                                { showFrame && <iframe loading="lazy" src={`${contentUrl}${report}`} title={title} className="h-screen min-h-80 w-full"></iframe> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    );
}
export default FileDetails;